module.exports = __webpack_public_path__ + "static/media/suplementos1.3fec33f7.png";